import type { JSX } from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import { BASE } from 'common/src/routes/BaseRoutes';

interface NoDataDisplayParams {
  filterItemsCount: number;
  hasEnabledSubtypes: boolean;
}

export const getNoAlertsDataDisplay = ({
  filterItemsCount,
  hasEnabledSubtypes,
}: NoDataDisplayParams): string | JSX.Element => {
  if (!hasEnabledSubtypes) {
    return (
      <Typography variant="body2">
        No alert preferences have been enabled, you must enable alert
        preferences to view alerts.{' '}
        <Link to={BASE.USER_SETTINGS}>Enable them in your user settings</Link>.
      </Typography>
    );
  }

  if (filterItemsCount > 0) {
    return 'No alerts matching the current filter(s) were found.';
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <Typography variant="body1">You're all caught up! </Typography>
      <Typography variant="body2">
        No alerts were reported for your organization.
      </Typography>
    </Box>
  );
};
